const EN_TO_BN: Record<string, string> = {
  "0": "০", "1": "১", "2": "২", "3": "৩", "4": "৪",
  "5": "৫", "6": "৬", "7": "৭", "8": "৮", "9": "৯",
};

const BN_TO_EN: Record<string, string> = Object.fromEntries(
  Object.entries(EN_TO_BN).map(([en, bn]) => [bn, en]),
);

export function toBengaliNumerals(input: string | number): string {
  return String(input).replace(/[0-9]/g, (d) => EN_TO_BN[d] ?? d);
}

export function toEnglishNumerals(input: string): string {
  return input.replace(/[০-৯]/g, (d) => BN_TO_EN[d] ?? d);
}

export function localizeNumber(value: string | number, lang: "en" | "bn"): string {
  return lang === "bn" ? toBengaliNumerals(value) : String(value);
}
